import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/scratch-pad/bulk-upload-images-machine-types")({
    loader: () => { },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
